<template>
  <div>
    <hero-section />
    <WhatWeOffer />
    <why-choose-us />
    <!-- <learn-skill /> -->
    <!-- <arduino-section /> -->
    <TrainingSection/>
    <ValueSection />
    <!-- <products-section /> -->
    <reviews-section />
    <!-- <partners-section /> -->
    <section class="py-5 container-fluid contact-box">
      <contact />
    </section>
  </div>
</template>

<script>
import HeroSection from "@/components/home/HeroSection.vue";
import WhatWeOffer from "@/components/home/WhatWeOffer.vue";
import WhyChooseUs from "@/components/home/WhyChooseUs.vue";
import LearnSkill from "@/components/home/LearnSkill.vue";
import ArduinoSection from "@/components/home/ArduinoSection.vue";
import ValueSection from "@/components/home/ValueSection.vue";
import TrainingSection from "@/components/home/TrainingSection.vue";
import ProductsSection from "@/components/home/ProductsSection.vue";
import ReviewsSection from "@/components/home/ReviewsSection.vue";
import PartnersSection from "@/components/home/PartnersSection.vue";
import Contact from "@/components/Contact.vue";
export default {
  components: {
    HeroSection,
    WhatWeOffer,
    WhyChooseUs,
    LearnSkill,
    ArduinoSection,
    ValueSection,
    ProductsSection,
    ReviewsSection,
    PartnersSection,
    Contact,
    TrainingSection
  },
};
</script>

<style>
.contact-box {
  background: #f9f9f9;
}
</style>